"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHydrogenBondAcceptorCount = void 0;
const getNumberProperties_1 = require("./getNumberProperties");
/**
 * Returns the hydrogen bond acceptor count of a compound
 *
 * @param data Data of a compound data request to the PubChem API
 * @returns Computed Data
 */
function getHydrogenBondAcceptorCount(data) {
    const hydrogenBondAcceptorCount = (0, getNumberProperties_1.getNumberProperties)(data, 'Hydrogen Bond Acceptor Count');
    return hydrogenBondAcceptorCount;
}
exports.getHydrogenBondAcceptorCount = getHydrogenBondAcceptorCount;
//# sourceMappingURL=getHydrogenBondAcceptorCount.js.map